import {publishOpenCopilotChat} from '@github-ui/copilot-chat/utils/copilot-chat-events'
import {CopilotChatIntents, type FileDiffReference} from '@github-ui/copilot-chat/utils/copilot-chat-types'
import {copilotFeatureFlags} from '@github-ui/copilot-chat/utils/copilot-feature-flags'
import {copilotLocalStorage} from '@github-ui/copilot-chat/utils/copilot-local-storage'
import {sendEvent} from '@github-ui/hydro-analytics'
import {ActionList} from '@primer/react'

export interface DiffLinesExplainMenuItemProps {
  fileDiffReference: FileDiffReference
  eventContext?: Parameters<typeof sendEvent>[1]
  afterSelect?: () => void
}

export const DiffLinesExplainMenuItem: React.FC<DiffLinesExplainMenuItemProps> = ({
  fileDiffReference,
  eventContext,
  afterSelect,
}) => {
  const handleExplain = () => {
    sendEvent('copilot.file-diff.explain', eventContext)
    if (copilotFeatureFlags.copilotRedirectDiffViewToImmersive) {
      copilotLocalStorage.setCopilotDiffReferences(fileDiffReference)
      copilotLocalStorage.setEntrypointMessage('Explain')
      window.location.href = '/copilot'
    } else {
      publishOpenCopilotChat({
        content: 'Explain',
        intent: CopilotChatIntents.explainFileDiff,
        references: [fileDiffReference],
      })
      afterSelect?.()
    }
  }

  return <ActionList.Item onSelect={handleExplain}>Explain</ActionList.Item>
}

try{ DiffLinesExplainMenuItem.displayName ||= 'DiffLinesExplainMenuItem' } catch {}